<template>
  <van-popup
    class="logistics-dialog"
    :value="show"
    :close-on-click-overlay="false"
    @input="onUpdateShow"
  >
    <div class="dialog-content">
      <!-- 头部 -->
      <div class="dialog-header">
        <div class="header-left"></div>
        <div class="header-title"></div>
        <div class="header-right">
          <div class="close-btn" @click="handleClose">
            <img src="@/assets/icons/closer.svg" alt="" />
          </div>
        </div>
      </div>
      
      <!-- 内容区域 -->
      <div class="content-area">
        <div class="content-title">顺丰同城暂时无人接单</div>
        <div class="content-text">
          您可以选择重新下单顺丰同城<br>
          或选择其他物流方式
        </div>
      </div>
      
      <!-- 按钮区域 -->
      <div class="dialog-buttons">
        <van-button class="btn-secondary" @click="handleOtherLogistics">
          其他物流方式
        </van-button>
        <van-button class="btn-primary" type="primary" @click="handleContinueOrder">
          继续下单
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'LogisticsDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onUpdateShow(value) {
      this.$emit('update:show', value)
    },
    handleClose() {
      this.$emit('update:show', false)
      this.$emit('close')
    },
    handleOtherLogistics() {
      this.$emit('other-logistics')
      this.handleClose()
    },
    handleContinueOrder() {
      this.$emit('continue-order')
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.logistics-dialog {
  width: 320/20rem;
  background: #FFFFFF;
  border-radius: 10/20rem;
  overflow: hidden;
  
  .dialog-content {
    padding: 0;
  }
}

.dialog-header {
  display: flex;
  align-items: center;
  padding: 10/20rem 10/20rem 6/20rem;
  height: 38/20rem;
  
  .header-left {
    width: 22/20rem;
  }
  
  .header-title {
    flex: 1;
    height: 22/20rem;
  }
  
  .header-right {
    width: 22/20rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .close-btn {
    width: 22/20rem;
    height: 22/20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    img {
      width: 100%;
      height: 100%;
    }
    
    &:hover {
      opacity: 0.7;
    }
  }
}

.dialog-content {
  padding: 6/20rem 20/20rem;
  text-align: center;
  
  .content-title {
    font-family: 'PingFang SC', sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.333;
    color: #000000;
    margin-bottom: 6/20rem;
  }
  
  .content-text {
    font-family: 'PingFang SC', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.417;
    letter-spacing: 0.35px;
    color: #7D7D7D;
    padding: 0 20/20rem 15/20rem;
  }
}

.dialog-buttons {
  display: flex;
  gap: 12/20rem;
  padding: 16/20rem 20/20rem 20/20rem;
  
  .btn-secondary {
    flex: 1;
    height: 38/20rem;
    border-radius: 4/20rem;
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.714;
    background: #FFFFFF;
    color: #000000;
    border: 1px solid #000000;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:active {
      opacity: 0.6;
    }
  }
  
  .btn-primary {
    flex: 1;
    height: 38/20rem;
    border-radius: 4/20rem;
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.714;
    background: #000000;
    color: #FFFFFF;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:active {
      opacity: 0.6;
    }
  }
}
</style> 